import React, { Component, useMemo } from "react";
import PropTypes from "prop-types";

import { domainFunctions } from "../oro-module/domainFunctions";
import { FaCheck, FaEnvelopeOpenText } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { currencyCommas, sentenceCase, toTitleCase, camelCase, toDate, number2text, getObjectsValue } from "../oro-module/commonFunctions";


function convertBoxValues(boxvalue, displaytype) {
  if (displaytype == 'currency') {
    boxvalue = currencyCommas(boxvalue)
  } else if (displaytype == 'date') {
    boxvalue = boxvalue ? toDate(boxvalue) : '';
  } else if (displaytype == 'capital' || displaytype == 'uppercase') {
    boxvalue = boxvalue.toUpperCase()
  } else if (displaytype == 'small') {
    boxvalue = boxvalue.toLowerCase();
  } else if (displaytype == 'sentencecase') {
    boxvalue = sentenceCase(boxvalue)
  } else if (displaytype == 'titlecase') {
    boxvalue = toTitleCase(boxvalue)
  } else if (displaytype == 'camelcase') {
    boxvalue = camelCase(boxvalue)
  } else if (displaytype == 'yesno') {
    boxvalue = (boxvalue && boxvalue != "") ? "YES" : "NO";
  }
  else if (displaytype == 'tick') {
    boxvalue = (boxvalue && boxvalue != "") ? <FaCheck style={{ fontSize: "12px", verticalAlign: "middle", borderColor: "black", color: "#2C3644" }} /> : <MdClose style={{ fontSize: "12px", verticalAlign: "middle", borderColor: "black", color: "#2C3644", fontWeight: "bold" }} />;
  } else if (displaytype == 'cheque_status') {
    let def = { 0: 'OK', 1: 'Executed', 2: 'Already stopped', 3: 'Released', 4: 'Bounced', 5: 'Cancelled' };
    boxvalue = def[boxvalue];
  } else if (displaytype == 'in_words') {
    boxvalue = number2text(boxvalue);
  }

  return boxvalue;
}

const GenerateData = (props) => {

  const getLatestValue = ({ formula, allvals, displaytype }) => {
    console.log("expensive calculation");
    let val;
    if (!formula) {
      val = allvals[0];
    } else if (formula) {
      for (var i = 0; i < formula.length; i++) {
        let form = formula[i];
        if (form.action == 'multiply') {
          val = !val ? 1 : val;
          allvals.map(av => val = val * av)
          if (form.mult) {
            val = val * form.mult;
          }
        }
        else if (form.action == 'sum') {
          val = !val ? 0 : val;
          allvals.map(av => val = !isNaN(parseFloat(av)) ? val + parseFloat(av) : val)
        } else if (form.action == 'setvar') {
          props.liftState({ name: form.name }, val);
        }
      }
    }

    if (displaytype && (val || val == 0)) {
      val = convertBoxValues(val, displaytype);
    }
    return val;
  }

  let { parentState } = props;
  let { name, style, font, isRequired, displaytype, data, formula } = props.component;
  let { pageData, LocalVars, modalname } = parentState;
  let boxvalue;
  if (!style) {
    style = {};
  }
  if (!style.backgroundColor) { style.backgroundColor = "#F1F1F1"; }
  if (!style.color) { style.color = "#000000"; }
  if (displaytype && (displaytype == 'currency' || displaytype == 'date') && !style.textAlign) {
    style.textAlign = "right";
  }

  let { compressed } = LocalVars;

  let allvals = [];
  if (data) {
    allvals.push(pageData[data]);
  } else if (formula) {
    for (var i = 0; i < formula.length; i++) {
      let form = formula[i];
      if (["multiply", "sum"].indexOf(form.action) != -1) {
        form.datavars.map(dv => {
          if (dv.name) {
            allvals.push(dv.mult * pageData[dv.name])
          } else {
            allvals.push(pageData[dv])
          }
        });
      }
    }
  }

  boxvalue = useMemo(() => getLatestValue({ allvals, formula, displaytype }), allvals);
  // boxvalue = allvals[0];

  return (
    <div
      className={`form-group  ${props.component.widths.parent}`}
    >
      <div
        style={style}
        className={`tinyscrollbar showdata ${!compressed ? 'showdatacustom-compressed' : "showdatacustom"}`}
      >
        {boxvalue ? boxvalue : ""}

      </div>

    </div>
  );
}


export default GenerateData;
